<template>
  <div class="chart1">
    <Doughnut
    :chart-options="chartOptions"
    :chart-data="computedData"
    />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  components: {
    Doughnut
  },
  props: {
    chartData:{
    required:true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        borderWidth: 0,
        cutout: '80%',
        borderRadius: 5,
        offset: 10,

      },

    }
  },
  computed:{
    computedData(){
      let data=this.chartData
      delete data.total 
      return {
        //labels:Object.keys(data),
        labels:['Demo Users','Paid Users'],
        datasets:[{
           backgroundColor: ['#2CD9C5', '#826AF9'],
          data:Object.values(data)
        }
        
        ]
      }
    }
  },
  mounted(){

  }
}
</script>
<style>
/* .chart1{
  height: 80%;
  width: 80%;
} */
</style>